import { useForm } from "react-hook-form";
import { UPDATE_EMBED_JS } from "./query";
import { FormContainer, TextInput, TextareaInput } from "../shared";
import useGlobalMutation from "../../hooks/useGlobalMutation";
import { RegexPattern } from "../../utils";
import { updateCache } from "../../utils/cacheUtils";

const UpdateEmbedJS = ({ data }) => {
    const { id, embedJsKey, embedJs, demandNo } = data;

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        mode: "onChange",
        defaultValues: {
            embedJsKey,
            embedJs,
            demandNo,
        },
    });

    const { submitMutation, loading } = useGlobalMutation(UPDATE_EMBED_JS, (cache, result) => {
        const newEmbedJsConfig =
            result?.data?.updateAbbvieProEmbedJsSnippetCustom?.abbvieProEmbedJsSnippet;

        updateCache(cache, id, newEmbedJsConfig, "AbbvieProEmbedJsSnippet");
    });

    const submitAction = handleSubmit(async (data) => {
        const { embedJsKey, demandNo, embedJs } = data;

        const variables = {
            embedJsSnippet: { id, embedJsKey, demandNo, embedJs },
        };

        const dataPath = "updateAbbvieProEmbedJsSnippetCustom.abbvieProEmbedJsSnippet";
        await submitMutation(variables, dataPath, "Embed JS Updated Successfully");
    });

    return (
        <FormContainer
            submitAction={submitAction}
            loading={loading}
            submitButtonText="Update"
            submitBtnSm
        >
            <h5 className="mb-3">Update Embed JS</h5>
            <div className="row">
                <div className="col-md-6">
                    <TextInput
                        id="embedJsKey"
                        labelText="Embed JS Key"
                        {...register("embedJsKey", {
                            pattern: RegexPattern.nameWithoutSpace,
                            required: true,
                        })}
                        isInvalid={!!errors.embedJsKey}
                        required
                    />
                </div>
                <div className="col-md-6">
                    <TextInput
                        id="demandNo"
                        labelText="Demand No."
                        {...register("demandNo", {
                            pattern: RegexPattern.nameWithoutSpace,
                            required: true,
                        })}
                        isInvalid={!!errors.demandNo}
                        required
                    />
                </div>
                <div className="col-12">
                    <TextareaInput
                        id="embedJs"
                        labelText="Embed JS Code"
                        placeholder="Put your Embed JS Code"
                        {...register("embedJs", {
                            required: true,
                        })}
                        isInvalid={!!errors.embedJs}
                        required
                    />
                </div>
            </div>
        </FormContainer>
    );
};

export default UpdateEmbedJS;
